export const LOGGED_IN = "LOGGED_IN";
export const PROFILE_UPDATE = "PROFILE_UPDATE";
export const LOG_OUT = "LOG_OUT";

export const GET_SITE_SETTINGS_DATA = "GET_SITE_SETTINGS_DATA";

export const GET_2FA_DETAILS = "GET_2FA_DETAILS";
export const CLEAR_2FA_DETAILS = "CLEAR_2FA_DETAILS";
